import {useRef} from 'react'
import {useIntersectionObserver} from '@github-ui/swp-core/lib/hooks/use-intersection-observer'
import Styles from './PageDivider.module.css'
import {PageDividerTile, type PageDividerTileLayout} from '../../_shared/PageDividerTile/PageDividerTile'

interface PageDividerProps {
  type: 1 | 2 | 3
}

type TileDefinition = {
  layout: PageDividerTileLayout
  colors: readonly [background: `#${string}`, foreground: `#${string}`]
}

const TILE_DEFINITIONS = {
  1: [
    {layout: '1', colors: ['#FF7DED', '#08872B']},
    {layout: '2', colors: ['#583AF7', '#C05200']},
    {layout: '3', colors: ['#BBA00A', '#D9D9D9']},
    {layout: '4', colors: ['#168FFB', '#08872B']},
  ],
  2: [
    {layout: '5', colors: ['#d9d9d9', '#08872b']},
    {layout: '6', colors: ['#ae85ff', '#583af7']},
    {layout: '7', colors: ['#c05200', '#583af7']},
    {layout: '2', colors: ['#f73678', '#ae85ff']},
  ],
  3: [
    {layout: '7', colors: ['#178ffb', '#fafafa']},
    {layout: '5', colors: ['#ae85ff', '#583af7']},
    {layout: '2', colors: ['#08872b', '#ff7ded']},
    {layout: '4', colors: ['#d9d9d9', '#583af7']},
  ],
} as const satisfies Record<PageDividerProps['type'], readonly TileDefinition[]>

const TILE_ANIMATION_DELAYS = [0, 0.2, 0.4, 0.6] as const

export function PageDivider(props: PageDividerProps) {
  const pageDividerRef = useRef<HTMLDivElement>(null)
  const {isIntersecting} = useIntersectionObserver(pageDividerRef, {isOnce: true})

  return (
    <div ref={pageDividerRef} className={Styles.PageDivider} aria-hidden="true">
      {isIntersecting &&
        TILE_DEFINITIONS[props.type].map(({layout, colors}, index) => (
          <PageDividerTile key={layout} layout={layout} colors={colors} delay={TILE_ANIMATION_DELAYS[index] ?? 0} />
        ))}
    </div>
  )
}
